import { Toast } from '@capacitor/toast';
import { BarcodeScanner, BarcodeScannerOptions } from '@ionic-native/barcode-scanner';
import { IonActionSheet, IonAlert, IonBadge, IonButton, IonButtons, IonCol, IonContent, IonFooter, IonGrid, IonHeader, IonIcon, IonImg, IonInput, IonItem, IonLabel, IonList, IonListHeader, IonModal, IonNote, IonPage, IonRow, IonText, IonTextarea, IonTitle, IonToast, IonToolbar, isPlatform, useIonToast, useIonViewDidEnter } from '@ionic/react';
import { BrowserMultiFormatReader } from '@zxing/library';
import { addCircle, alertCircle, arrowBack, barcodeOutline, bookmark, bookmarkOutline, cardOutline, carOutline, checkmarkCircle, checkmarkCircleOutline, close, copyOutline, cubeOutline, eye, flag, flagOutline, hourglassOutline, informationCircleOutline, leafOutline, navigateOutline, personOutline, receiptOutline, timeOutline, trashOutline } from 'ionicons/icons';
import React, { useRef, useState } from 'react';
import { useHistory, useLocation, useParams } from 'react-router';
import { usePhotoGallery } from '../../../../../components/usePhotoGallery';
import { Boletos } from '../../../../../Utils/Boletos';
import { alterarNotaFiscal, encerrarOperacao, excluirBoleto, excluirNotaFiscal, incluiNotaFiscal, incluirBoleto, operacaoAlterarBookmark, operacaoAlterarValidacao, requestService, urlBase } from '../../../../../Utils/Services';
import "./Acompanhar.css";
import iconHorario from "./imgs/horario.svg";
import maps from './imgs/maps.png';
import iconTempo from "./imgs/tempo.svg";
import waze from './imgs/waze.png';
import { Buffer } from 'buffer';

type Props = {
  estabelecimento: string;
  codigoBarras: string;
  operacaoid: string;
  onDismiss: () => void;
};

let stream2: any;
let arrayDevices: any[] = []

const Acompanhar: React.FC<Props> = (props: Props) => {

  const inputRef = useRef<any>(null);

  const { photos, takePhoto, loadPhotos } = usePhotoGallery(props.operacaoid);
  const { calcula_barra, calcula_linha, funcFormataLinha } = Boletos();
  const history = useHistory<any>();
  const location = useLocation<any>();
  const [showBrowserCamera, setShowBrowserCamera] = useState(false);
  const [showBrowserCameraBoleto, setShowBrowserCameraBoleto] = useState(false);

  const [codigoBarras, setCodigoBarras] = React.useState<string>();
  const [codigoBarrasBoleto, setCodigoBarrasBoleto] = React.useState<string>();
  const [boletoValor, setBoletoValor] = React.useState<string>();
  const [boletoVencimento, setBoletoVencimento] = React.useState<string>();
  const [boletoBarra, setBoletoBarra] = React.useState<string>();
  const [boletoLinha, setBoletoLinha] = React.useState<string>();
  const [boletoNota, setBoletoNota] = React.useState<string>();
  const [alertConfirmarExcluirBoleto, setAlertConfirmarExcluirBoleto] = useState(false);
  const [stateSelectedBoleto, setStateSelectedBoleto] = useState("");
  const [stateSelectedBoletoPosicao, setStateSelectedBoletoPosicao] = useState(undefined);
  const [boletos, setBoletos] = useState<any>([]);

  const [abrirCompartilhar, setAbrirCompartilhar] = useState(false);
  const [abrirEncerrar, setAbrirEncerrar] = useState(false);
  const [abrirEncerrarDois, setAbrirEncerrarDois] = useState(false);
  const [dadosOperacao, setDadosOperacao] = useState<any>([]);
  const [operacaoCarregada, setOperacaoCarregada] = useState(false);
  const [horaInicio, setHoraInicio] = useState(new Date());
  const [horaFim, setHoraFim] = useState(new Date());
  const [temHoraFim, setTemHoraFim] = useState(false);
  const [tempoOperacao, setTempoOperacao] = useState("...");
  const [valorEstrela, setValorEstrela] = useState(0);
  const [textoEstrela, setTextoEstrela] = useState("Selecione");
  const [comentario, setComentario] = useState("");
  const [hideButton, setHideButton] = useState(true);
  const [showActionSheet, setShowActionSheet] = useState(false);
  const [alertConfirmar, setAlertConfirmar] = useState(false);
  const [alertConfirmarExcluirNotaFiscal, setAlertConfirmarExcluirNotaFiscal] = useState(false);
  const [stateShowAlertNotaInfo, setStateShowAlertNotaInfo] = useState(false);
  const [stateSelectedNota, setStateSelectedNota] = useState("");
  const [stateSelectedNotaAnotacao, setStateSelectedNotaAnotacao] = useState("");
  const [stateSelectedNotaPosicao, setStateSelectedNotaPosicao] = useState(undefined);
  const [showToastBookmark, setShowToastBookmark] = useState(false);
  const [notasAdicionais, setNotasAdicionais] = useState<any>([]);
  const [codeReader, setCodeReader] = React.useState(new BrowserMultiFormatReader());
  const [exibeTexto, setexibeTexto] = useState("");
  const [showCarregando, setShowCarregando] = useState(false);
  const [showModalCodigoBarrasDigitar, setShowModalCodigoBarrasDigitar] = useState(false);
  const [showModalBoletosDigitar, setShowModalBoletosDigitar] = useState(false);
  const [front, setFront] = useState(false);
  const [streamData, setStreamData] = useState<MediaStream>();
  const [alertaPreenchimento, setAlertaPreenchimento] = useState(false);
  const [botaoAtivo, setBotaoAtivo] = useState(true);

  const [present] = useIonToast();

  const presentToast = (position: 'top' | 'middle' | 'bottom', message: string) => {
    present({
      message: message,
      duration: 1500,
      position: position,
    });
  };

  useIonViewDidEnter(() => {
    document.getElementsByTagName("ion-tab-bar")[0].style.display = "none";

  });

  let params: any = {
    codigoBarras: "",
    estabelecimento: "",
    operacaoid: "",
  }
  params = useParams();

  if (location && location.state && location.state.operacaoid) {
    params.operacaoid = location.state.operacaoid;
  }


  if (props.operacaoid) {
    params = {
      codigoBarras: props.codigoBarras,
      estabelecimento: props.estabelecimento,
      operacaoid: props.operacaoid
    }
  }

  var estabelecimento = {
    nome: params.estabelecimento,
    parceiro: false,
    endereco: "Rua Selvin Ln, 1035, São Paulo, SP",
    horarios: [
      { dia: "segunda-feira", inicio: "8:00", fim: "16:00", aberto: true },
      { dia: "terça-feira", inicio: "8:00", fim: "16:00", aberto: true },
      { dia: "quarta-feira", inicio: "8:00", fim: "16:00", aberto: true },
      { dia: "quinta-feira", inicio: "8:00", fim: "16:00", aberto: true },
      { dia: "sexta-feira", inicio: "8:00", fim: "16:00", aberto: true },
      { dia: "sábado", inicio: "8:00", fim: "16:00", aberto: true },
      { dia: "domingo", inicio: "8:00", fim: "16:00", aberto: false },
    ],
    medias: {
      historico: "45 min",
      hoje: "1h 30min"
    }
  }

  function tempoCorrido(horario: Date, dataFim?: Date) {
    var g = Math.ceil(((dataFim ? dataFim.getTime() : Date.now()) - horario.getTime()) / 1000 / 60);
    var tempoApurado = Math.floor(g / 60).toString() + 'h' + ('0' + (g % 60).toString()).substr(-2) + 'min';
    return tempoApurado !== "0h00min" ? tempoApurado : "0h01min";
  }

  function carregarOperacao() {
    //console.log(params.operacaoid);
    if (params.operacaoid != "" && params.operacaoid != undefined) {
      if (!operacaoCarregada) {
        setOperacaoCarregada(true);

        var token: string = "";
        var tkn = localStorage.getItem("token");
        if (typeof (tkn) === "string") { token = tkn; }
        const getoperacao = async () => {
          const resp = await fetch(urlBase.url + "/operacoes/operacao%23" + params.operacaoid,
            {
              method: urlBase.method,
              headers: [
                ["token", token]
              ],
              credentials: 'include'
            });
          const operacao = await resp?.json();
          //if (resp.status === 400 || resp.status === 401) history.replace("/login/");
          if (operacao.Item !== undefined) {
            setDadosOperacao(operacao);
            //console.log('operacao', operacao);
            setHideButton(operacao.Item.sk.startsWith("usuarios#") ? false : false);
            setHoraInicio(new Date(operacao.Item.dataInicio));
            setTemHoraFim(operacao.Item.dataEncerramento ? true : false);
            setHoraFim(operacao.Item.dataEncerramento ? new Date(operacao.Item.dataEncerramento) : new Date());
            setTempoOperacao(tempoCorrido(new Date(operacao.Item.dataInicio), operacao.Item.dataEncerramento ? new Date(operacao.Item.dataEncerramento) : new Date()));
            setNotasAdicionais(operacao.Item.notasAdicionais || []);
            setBoletos(operacao.Item.boletos || []);

            if (operacao.Item.photo) {


              let _photos: string[] = operacao.Item.photo;
              loadPhotos(_photos);

            }

          }

        }

        getoperacao();
      }
    }
    return "";
  }

  setInterval(() => setTempoOperacao(tempoCorrido(horaInicio)), 60000);

  function loadHorarios() {
    return estabelecimento.horarios.map((value, index) => {
      return (
        <div className="horario" key={index}>
          <IonLabel placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{value.dia}</IonLabel>
          <IonLabel placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{value.aberto ? value.inicio + " - " + value.fim : "Fechado"}</IonLabel>
        </div>);
    });

  }

  async function encerrar() {
    const realizarEncerramento = async () => {

      var token: string = "";
      var tkn = localStorage.getItem("token");
      if (typeof (tkn) === "string") { token = tkn; }

      const resp = await fetch(encerrarOperacao.url.replace("{id}", "operacao%23" + params.operacaoid),
        {
          method: encerrarOperacao.method,
          headers: [
            ["token", token]
          ],
          credentials: 'include'
        });

      const res = await resp.json();
      if (res.message) {
        //console.log(res);
        history.replace("/cliente/operacoesNovo", { recarregar: true });
      }
    }
    await realizarEncerramento();
  }

  function encerrar2() {
    var token: string = "";
    var tkn = localStorage.getItem("token");
    if (typeof (tkn) === "string") { token = tkn; }

    return fetch(encerrarOperacao.url.replace("{id}", "operacao%23" + params.operacaoid),
      {
        method: encerrarOperacao.method,
        headers: [
          ["token", token]
        ],
        credentials: 'include'
      });
  }


  function adicionaZeroNaData(numero: any) {
    if (numero <= 9)
      return "0" + numero;
    else
      return numero;
  }

  function formatarData(data: Date) {
    return (adicionaZeroNaData(data.getDate().toString()) + "/" + (adicionaZeroNaData(data.getMonth() + 1).toString()) + "/" + data.getFullYear().toString().substr(2));
  }

  function formatarDataHora(data: Date) {
    return adicionaZeroNaData(data.getDate().toString()) + "/" + (adicionaZeroNaData(data.getMonth() + 1).toString()) + " " + ("0" + data.getHours().toString()).substr(-2) + ":" + ("0" + data.getMinutes().toString()).substr(-2);
  }

  function ajustaTextoEstrela(value: any) {
    if (value === 1) setTextoEstrela("Muito ruim");
    if (value === 2) setTextoEstrela("Ruim");
    if (value === 3) setTextoEstrela("Normal");
    if (value === 4) setTextoEstrela("Bom");
    if (value === 5) setTextoEstrela("Excelente");
  }

  const openScanner = async () => {
    if (isPlatform("mobileweb") || isPlatform("desktop")) {
      setShowBrowserCamera(true);
    }
    else {

      const opt: BarcodeScannerOptions = {
        formats: 'CODE_128',
        prompt: 'Escaneie o codigo de barras'
      }

      const data: any = await BarcodeScanner.scan(opt);

      if (data !== null) {
        setShowCarregando(true);
        registrarNotaFiscal(data.text);
      }
    }
  };

  function registrarNotaFiscal(valor: any) {

    if (valor === undefined || valor.replace(' ', '') === '') {
      setAlertaPreenchimento(true);
    }
    else {
      setShowCarregando(true);
      let objeto = { "notaFiscal": valor.toString().replace(/ /g, ""), "tipoOperacao": "Indefinida" };

      const registrar = () => {
        requestService(incluiNotaFiscal.url.replace("{id}", params.operacaoid.replace(/"#"/g, "%23")), {
          method: incluiNotaFiscal.method,
          headers: [
            ["token", window.localStorage.getItem("token")]
          ],
          body: JSON.stringify(objeto),
          credentials: 'include'
        },
          history,
          (response: any) => {
            let objeto = { "notaFiscal": valor.toString(), "tipoOperacao": "Indefinida" };
            let incremento = notasAdicionais;
            incremento.push(objeto);
            setNotasAdicionais(incremento);
            Toast.show({
              text: "Sucesso na inclusão da nota",
              duration: "long"
            });
            window.localStorage.setItem("reloadOperacoes", "sim");
            setShowBrowserCamera(false);
            setShowModalCodigoBarrasDigitar(false);
            setCodigoBarras('');
            setShowCarregando(false);
            //setexibeTexto(JSON.stringify(response));
          },
          (error: any) => {
            Toast.show({
              text: "Erro na inclusão da nota",
              duration: "long"
            });
            setShowBrowserCamera(false);
            setShowCarregando(false);
          });
      }

      registrar();
    }
  }

  function funcAlterarNotaFiscal(posicao: any, anotacao: any) {
    console.log("entrou", posicao, anotacao)
    if (posicao === undefined || anotacao === undefined) {
      setAlertaPreenchimento(true);
    }
    else {
      console.log("entrou2")
      setShowCarregando(true);
      let objeto = {
        "posicao": posicao.toString().replace(/ /g, ""),
        "anotacao": anotacao.toString() || ""
      };

      const registrar = () => {
        requestService(alterarNotaFiscal.url.replace("{id}", params.operacaoid.replace(/"#"/g, "%23")), {
          method: alterarNotaFiscal.method,
          headers: [
            ["token", window.localStorage.getItem("token")]
          ],
          body: JSON.stringify(objeto),
          credentials: 'include'
        },
          history,
          (response: any) => {
            let incremento = notasAdicionais;
            incremento[objeto.posicao].anotacao = objeto.anotacao;
            setNotasAdicionais(incremento);

            Toast.show({
              text: "Sucesso na alteração da nota",
              duration: "long"
            });
            window.localStorage.setItem("reloadOperacoes", "sim");
            setShowCarregando(false);
          },
          (error: any) => {
            console.log(error)
            Toast.show({
              text: "Erro na alteração da nota",
              duration: "long"
            });
            setShowCarregando(false);
          });
      }

      registrar();
    }
  }

  function funcExcluirNotaFiscal(posicao: any) {
    console.log("entrou", posicao)
    console.log("entrou2")
    setShowCarregando(true);
    let objeto = {
      "posicao": posicao.toString().replace(/ /g, "")
    };

    const registrar = () => {
      requestService(excluirNotaFiscal.url.replace("{id}", params.operacaoid.replace(/"#"/g, "%23")), {
        method: excluirNotaFiscal.method,
        headers: [
          ["token", window.localStorage.getItem("token")]
        ],
        body: JSON.stringify(objeto),
        credentials: 'include'
      },
        history,
        (response: any) => {

          if (response.data) {
            setNotasAdicionais(response.data.notasAdicionais);

            Toast.show({
              text: "Sucesso na exclusão da nota",
              duration: "long"
            });
            window.localStorage.setItem("reloadOperacoes", "sim");
          }
          else {
            Toast.show({
              text: "Erro na exlusão da nota",
              duration: "long"
            });
          }
          setShowCarregando(false);
        },
        (error: any) => {
          console.log(error)
          Toast.show({
            text: "Erro na exlusão da nota",
            duration: "long"
          });
          setShowCarregando(false);
        });
    }

    registrar();

  }

  function funcRegistrarBoleto(boleto: any, nota: any, vencimento: any) {
    console.log(boleto);
    if (boleto === undefined || boleto.replace(' ', '') === '') {
      setAlertaPreenchimento(true);
    }
    else {
      setShowCarregando(true);
      let objeto = {
        "notaFiscal": boletoNota || "".toString().replace(/ /g, ""),
        "boleto": boleto,
        "vencimento": vencimento
      };

      const registrar = () => {
        requestService(incluirBoleto.url.replace("{id}", params.operacaoid.replace(/"#"/g, "%23")), {
          method: incluirBoleto.method,
          headers: [
            ["token", window.localStorage.getItem("token")]
          ],
          body: JSON.stringify(objeto),
          credentials: 'include'
        },
          history,
          (response: any) => {

            let objeto = {
              "linhaDigitavel": boleto.toString(),
              "notaFiscal": (boletoNota || "").toString().replace(/ /g, ""),
              "valor": (Math.round(boleto.substr(37, 10)) / 100).toFixed(2),
              "vencimento": vencimento
            };
            let incremento = boletos;
            incremento.push(objeto);
            setBoletos(incremento);
            Toast.show({
              text: "Sucesso na inclusão",
              duration: "long"
            });
            window.localStorage.setItem("reloadOperacoes", "sim");
            setShowBrowserCamera(false);
            setShowModalBoletosDigitar(false);
            setCodigoBarrasBoleto('')
            setBoletoNota('');
            setShowCarregando(false);
            //setexibeTexto(JSON.stringify(response));
          },
          (error: any) => {
            Toast.show({
              text: "Erro na inclusão",
              duration: "long"
            });
            setShowBrowserCamera(false);
            setShowCarregando(false);
          });
      }

      registrar();
    }
  }

  function funcExcluirBoleto(posicao: any) {
    console.log("entrou", posicao)
    console.log("entrou2")
    setShowCarregando(true);
    let objeto = {
      "posicao": posicao.toString().replace(/ /g, "")
    };

    const registrar = () => {
      requestService(excluirBoleto.url.replace("{id}", params.operacaoid.replace(/"#"/g, "%23")), {
        method: excluirBoleto.method,
        headers: [
          ["token", window.localStorage.getItem("token")]
        ],
        body: JSON.stringify(objeto),
        credentials: 'include'
      },
        history,
        (response: any) => {

          if (response.data) {
            setBoletos(response.data.boletos);

            Toast.show({
              text: "Sucesso na exclusão do boleto",
              duration: "long"
            });
            window.localStorage.setItem("reloadOperacoes", "sim");
          }
          else {
            Toast.show({
              text: "Erro na exlusão da nota",
              duration: "long"
            });
          }
          setShowCarregando(false);
        },
        (error: any) => {
          console.log(error)
          Toast.show({
            text: "Erro na exlusão da nota",
            duration: "long"
          });
          setShowCarregando(false);
        });
    }

    registrar();

  }

  function cancelarScan() {
    if (codeReader) {
      codeReader.stopAsyncDecode();
      codeReader.stopContinuousDecode();
    }

    console.log(streamData);
    if (streamData) {
      streamData.getVideoTracks().forEach((valor: MediaStreamTrack) => {
        console.log(valor);
        valor.stop();
      });
    }
  }

  function startCamera() {
    if (arrayDevices.length == 0) {
      console.log("loadDevices");
      navigator.mediaDevices
        .enumerateDevices()
        .then(gotDevices)
        .then(getStream)
        .catch((err) => { console.log(err); });
    } else {
      getStream();
    }
  }

  function getStream() {
    if (stream2) {
      stream2.getTracks().forEach(function (track: any) {
        console.log("getTracks");
        track.stop();
      });
    }

    //document.getElementById('flip-button').onclick = function() { setFront(!front); };

    const constraints = {
      audio: false,
      video: {
        width: 1024,
        height: 576,
        facingMode: (front ? "user" : "environment")
        //facingMode: { exact: "environment" }

        //deviceId: { exact: arrayDevices[selectedCamera] },
      },
    };

    navigator.mediaDevices
      .getUserMedia(constraints)
      .then(gotStream)
      .catch((err) => { console.log(err) });
  }

  function gotDevices(deviceInfos: any) {
    //console.log("getDevices");
    for (let i = 0; i !== deviceInfos.length; ++i) {
      const deviceInfo = deviceInfos[i];
      if (deviceInfo.kind === "videoinput") {
        arrayDevices.push(deviceInfo.deviceId);
      }
    }
  }

  function gotStream(stream: MediaStream) {
    setStreamData(stream);
    //console.log("gotStream");
    const videoElement = document.getElementById("video") as HTMLVideoElement;

    videoElement.srcObject = stream;
    codeReader.decodeFromStream(stream, videoElement, (result: any) => {
      if (result) {
        codeReader.stopAsyncDecode();
        codeReader.stopContinuousDecode();
        stream.getVideoTracks().forEach((valor: MediaStreamTrack) => {
          //console.log(valor);
          valor.stop();
        });
        registrarNotaFiscal(result.text.toString());
        //setShowBrowserCamera(false);
      } else {

      }
    }).catch((err) => { console.log(err) });

  }

  function space(str: any, after: any) {
    setAlertaPreenchimento(false);

    if (!str) {
      setCodigoBarras('');
      return false;
    }
    after = after || 4;
    var v = str.replace(/[^\dA-Z]/g, ''),
      reg = new RegExp(".{" + after + "}", "g");
    setCodigoBarras(
      v.replace(reg, function (a: any) {
        return a + ' ';
      })
    );
  };

  function validaBoleto(param: any) {
    if (param.length === 44) {
      let linha = calcula_linha(param); //26097994200003500001705474325722141380000000
      if (!linha) return;
      let vencimento = new Date(1997, 9, 7)
      let diasVencimento = linha.replace(/ /g, "").replaceAll(".", "").substr(33, 4);
      if (diasVencimento < 9000) {
        diasVencimento = parseInt(diasVencimento) + 9000;
      }
      let valor = linha.replace(/ /g, "").replaceAll(".", "").substr(37, 10);
      let barra = param;
      console.log('dias', linha.replace(/ /g, "").replaceAll(".", "").substr(33, 4))
      console.log('dias', linha.replace(/ /g, "").replaceAll(".", ""))
      vencimento.setDate(vencimento.getDate() + parseInt(diasVencimento));
      setBoletoVencimento(diasVencimento == '0000' ? '' : vencimento.toLocaleString('pt-BR').split(',')[0]);
      setBoletoLinha(linha);
      setBoletoValor((Math.round(valor) / 100).toFixed(2))
      setBoletoBarra(barra);
    }
    else if (param.length === 47) {
      let barra = calcula_barra(param);
      if (!barra) return;
      let linha = param; //26091705497432572214313800000005799420000350000
      let vencimento = new Date(1997, 9, 7)
      let diasVencimento = linha.replace(/[^0-9]/g, '').substr(33, 4);
      if (diasVencimento < 9000) {
        diasVencimento = parseInt(diasVencimento) + 9000;
      }
      let valor = linha.replace(/[^0-9]/g, '').substr(37, 10);
      vencimento.setDate(vencimento.getDate() + parseInt(diasVencimento));
      setBoletoVencimento(diasVencimento == '0000' ? 'Indefinido' : vencimento.toLocaleString('pt-BR').split(',')[0]);
      setBoletoLinha(funcFormataLinha(linha));
      setBoletoValor((Math.round(valor) / 100).toFixed(2))
      setBoletoBarra(barra);
    }
    else {
      setBoletoVencimento('Indefinido');
      setBoletoLinha('');
      setBoletoValor('');
      setBoletoBarra('');
    }
    setCodigoBarrasBoleto(param || "");
  }

  function funcCopy(linha: any) {
    //let linha = calcula_linha(barra).replace(/[^0-9]/g, '');
    navigator.clipboard.writeText(linha).then(() => { Toast.show({ text: "Boleto copiado", duration: "short", position: 'bottom' }); });
  }

  function funcCopyNota(value: any) {
    navigator.clipboard.writeText(value).then(() => { Toast.show({ text: "Copiado", duration: "short", position: 'bottom' }); });
  }

  const isValidDate = (dateString: any) => {
    // Regex para verificar o formato dd/mm/yyyy
    const regex = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/;
    if (!regex.test(dateString)) {
      return false;
    }
    else {
      return true;
    }
  };

  const formatDate = (value: string) => {
    // Remove caracteres não numéricos
    const cleaned = value.replace(/\D/g, "");

    // Adiciona as barras conforme o usuário digita
    let formatted = cleaned;
    if (cleaned.length > 2) formatted = `${cleaned.slice(0, 2)}/${cleaned.slice(2)}`;
    if (cleaned.length > 4) formatted = `${formatted.slice(0, 5)}/${formatted.slice(5, 9)}`;

    return formatted;
  };

  const handleInputChange = (e: any) => {
    const value = e.detail.value!;
    setBoletoVencimento(formatDate(value));
  };

  function changeDataValidacao(validacao: any) {
    setShowCarregando(true);
    let objeto = { "validacao": validacao ? false : true };

    const registrar = () => {
      requestService(operacaoAlterarValidacao.url.replace("{pk}", dadosOperacao.Item.pk.replace(/#/g, '%23')), {
        method: operacaoAlterarValidacao.method,
        headers: [
          ["token", window.localStorage.getItem("token")]
        ],
        body: JSON.stringify(objeto),
        credentials: 'include'
      },
        history,
        (response: any) => {
          if (validacao) {
            setDadosOperacao((prevState: any) => ({ ...prevState, Item: { ...prevState.Item, dataValidacao: null } }));
          }
          else {
            setDadosOperacao((prevState: any) => ({ ...prevState, Item: { ...prevState.Item, dataValidacao: new Date().toISOString() } }))
          }
          Toast.show({
            text: "Sucesso na marcação da validação",
            duration: "long"
          });
          //window.localStorage.setItem("reloadOperacoes", "sim");
        },
        (error: any) => {
          Toast.show({
            text: "Erro na marcação da validação",
            duration: "long"
          });
        }).finally(() => {
          setShowCarregando(false);
        });
    }

    registrar();
  }

  function changeBookmark(bookmark: any) {
    setShowCarregando(true);
    let objeto = { "cliente": bookmark ? null : dadosOperacao.Item.gsi2pk }; //altera para null caso seja preenchido ou preenche caso seja nulo o bookmark

    const registrar = () => {
      requestService(operacaoAlterarBookmark.url.replace("{pk}", dadosOperacao.Item.pk.replace(/#/g, '%23')), {
        method: operacaoAlterarBookmark.method,
        headers: [
          ["token", window.localStorage.getItem("token")]
        ],
        body: JSON.stringify(objeto),
        credentials: 'include'
      },
        history,
        (response: any) => {
          if (bookmark) {
            setDadosOperacao((prevState: any) => ({ ...prevState, Item: { ...prevState.Item, gsi5pk: null } }));
          }
          else {
            setDadosOperacao((prevState: any) => ({ ...prevState, Item: { ...prevState.Item, gsi5pk: dadosOperacao.Item.gsi2pk } }))
          }
          Toast.show({
            text: "Sucesso na marcação da operação",
            duration: "long"
          });
          //window.localStorage.setItem("reloadOperacoes", "sim");
        },
        (error: any) => {
          Toast.show({
            text: "Erro na marcação da operação",
            duration: "long"
          });
        }).finally(() => {
          setShowCarregando(false);
        });
    }

    registrar();
  }

  return (

    <IonPage className="Acompanhar" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
      <IonHeader className="ion-no-border" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
        <IonToolbar color="primary" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
          {carregarOperacao()}
          <IonButtons slot="start" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            <IonButton onClick={() => { history.goBack(); /*.replace("/cliente/operacoes", { recarregar: false }); */ }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
              <IonIcon slot="icon-only" icon={arrowBack} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} />
            </IonButton>
          </IonButtons>
          <IonItem lines="none" color="primary" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} >
            <IonTitle color="dark" className="ion-text-wrap" style={{ "paddingLeft": "20px", "paddingTop": "0px", "paddingBottom": "0px", "textAlign": "left" }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{dadosOperacao.Item ? dadosOperacao.Item.clienteNome : ""}</IonTitle>
            <IonBadge hidden={dadosOperacao.Item ? !dadosOperacao.Item.clienteParceiroSm : true} color="tertiary" slot="end" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} >parceiro</IonBadge>
          </IonItem>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen={false} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
        <IonModal isOpen={showCarregando} className='my-custom-class aguarde' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
          <IonLabel className="helper" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Aguarde, realizando operação</IonLabel>
        </IonModal>
        <IonModal isOpen={showBrowserCamera} onDidDismiss={() => { setShowBrowserCamera(false); cancelarScan(); }} className='my-custom-class camera' onDidPresent={() => { startCamera(); }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
          <video hidden={false} style={{ display: "flex", flexDirection: "column" }} id="video" autoPlay muted playsInline></video>
          <IonLabel className="helper" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Aponte a camera para o <b>código de barras</b> que será feita a leitura.</IonLabel>
          {/*
          <IonItem>
            <IonLabel hidden={false}>{notaLida}</IonLabel>
          </IonItem>
          */}
          <div className="actions" style={{ width: "100%", display: "flex", flexDirection: "column" }}>
            {/*<IonButton fill="clear" slot="end" color="tertiary" onClick={() => {registrarNotaFiscal("12345646545644252345324523452345432523452344324342654");}}>input</IonButton>*/}
            {/*<IonButton fill="solid" slot="end" color="tertiary" onClick={() => {cancelarScan();lerNotaFiscal();}}>Ler Chave de Acesso da Nota</IonButton>*/}
            <IonButton fill="solid" slot="end" color="tertiary" onClick={() => { setFront(!front); startCamera(); }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Virar camera</IonButton>
            <IonButton fill="clear" slot="end" color="tertiary" onClick={() => { cancelarScan(); setShowBrowserCamera(false); }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Cancelar</IonButton>
          </div>
        </IonModal>
        <IonModal isOpen={showModalCodigoBarrasDigitar} onDidPresent={() => { inputRef.current.setFocus(); }} onDidDismiss={() => { setShowModalCodigoBarrasDigitar(false); setCodigoBarras(''); setAlertaPreenchimento(false); }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} >
          <IonHeader placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            <IonToolbar color="primary" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
              <IonTitle placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Incluir Nota Fiscal</IonTitle>
              <IonButtons slot="start" onClick={() => { cancelarScan(); setShowModalCodigoBarrasDigitar(false); }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                <IonIcon slot="icon-only" icon={arrowBack} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}></IonIcon>
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent class="ion-padding" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            <IonItem lines="none" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
              <IonIcon hidden={!alertaPreenchimento} size="large" slot="start" src={alertCircle} color="danger" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} />
              <IonLabel hidden={!alertaPreenchimento} color="danger" style={{ "font-size": "14px" }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} >Campo obrigatório</IonLabel>
            </IonItem>
            <IonItem lines="none" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
              <IonLabel className="ion-text-wrap" position="stacked" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Informe a <b>chave de acesso</b> (código de barras) na <b>nota</b>:</IonLabel>
              <IonTextarea ref={(ref) => inputRef.current = ref} rows={3} inputMode="numeric" maxlength={54} value={codigoBarras} placeholder="Utilize o leitor de código de barras ou digite" onIonChange={e => space(e.detail.value!, 4)} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}></IonTextarea>
            </IonItem>
          </IonContent>
          <IonFooter className="ion-no-border" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} >
            <IonToolbar placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
              <IonButton expand="block" size='large' disabled={!botaoAtivo} onClick={() => { registrarNotaFiscal((codigoBarras || "").replace(/ /g, "")); }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Registrar Nota!</IonButton>
              <IonButton expand="block" fill="clear" color="tertiary" onClick={() => { openScanner(); }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Utilizar câmera do celular</IonButton>
            </IonToolbar>
          </IonFooter>
        </IonModal>
        <IonModal isOpen={showModalBoletosDigitar} onDidPresent={() => { inputRef.current.setFocus(); }} onDidDismiss={() => { setShowModalBoletosDigitar(false); setCodigoBarrasBoleto(''); setBoletoNota(''); setAlertaPreenchimento(false); }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} >
          <IonHeader placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            <IonToolbar color="primary" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
              <IonTitle placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Incluir Boletos</IonTitle>
              <IonButtons slot="start" onClick={() => { setShowModalBoletosDigitar(false); }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                <IonIcon slot="icon-only" icon={arrowBack} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}></IonIcon>
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent style={{ '--padding-start': '16px', '--padding-end': '16px' }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            <IonItem lines="none" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
              <IonLabel className="ion-text-wrap" position="stacked" style={{ fontSize: '18px' }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}><b>BOLETO</b></IonLabel>
              <IonTextarea style={{ background: "#EEEEEE", borderRadius: '25px', paddingLeft: '15px' }} ref={(ref) => inputRef.current = ref} rows={1} inputMode="numeric" maxlength={47} value={codigoBarrasBoleto} placeholder="Utilize o leitor de código de barras ou digite" onIonChange={e => validaBoleto(e.detail.value)} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}></IonTextarea>
            </IonItem>
            <IonItem lines="none" style={{ height: '56px' }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
              <IonIcon style={{ display: 'inline-block', verticalAlign: 'middle' }} hidden={!alertaPreenchimento} size="large" slot="start" src={alertCircle} color="danger" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} />
              <IonLabel style={{ display: 'inline-block', verticalAlign: 'middle', alignSelf: 'center' }} hidden={!alertaPreenchimento} color="danger" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}  >Campo obrigatório</IonLabel>
            </IonItem>
            <IonItem lines="none" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
              <IonLabel className="ion-text-wrap" position="stacked" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}><b>Nota</b>: </IonLabel>
              {/*<IonTextarea style={{ background: "#EEEEEE", paddingLeft: '15px' }} rows={1} inputMode="text" maxlength={100} value={boletoNota} placeholder="Digite a nota referente ao boleto" onIonChange={e => setBoletoNota(e.detail.value || "")}></IonTextarea>*/}
              <IonText placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{boletoNota}</IonText>
            </IonItem>
            <IonItem lines="none" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
              <IonLabel className="ion-text-wrap" position="stacked" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}><b>Valor</b> :</IonLabel>
              <IonText style={{ fontSize: '24px' }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{boletoValor}</IonText>
            </IonItem>
            <IonItem lines="none" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
              <IonLabel className="ion-text-wrap" position="stacked" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}><b>Linha Digitável</b> :</IonLabel>
              <IonText placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{boletoLinha}</IonText>
            </IonItem>
            <IonItem lines="none" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} >
              <IonLabel className="ion-text-wrap" position="stacked" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}><b>Vencimento</b>: </IonLabel>
              {/* <IonText>{boletoVencimento == "" ? "Sem vencimento" : boletoVencimento}</IonText> */}
              <IonInput maxlength={10} value={boletoVencimento} onIonChange={(e) => handleInputChange(e)} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}></IonInput>
            </IonItem>
          </IonContent>
          <IonFooter className="ion-no-border" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} >
            <IonToolbar placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
              <IonButton expand="block" size='large' disabled={!botaoAtivo} onClick={() => {
                if (isValidDate(boletoVencimento)) {
                  funcRegistrarBoleto((boletoLinha || "").replace(/[^0-9]/g, ''), null, boletoVencimento);
                }
                else {
                  Toast.show({ text: "Ajuste o formato da data (dd/mm/aaaa)", duration: "long", position: 'bottom' });
                }
              }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Registrar Boleto!</IonButton>
            </IonToolbar>
          </IonFooter>
        </IonModal>
        <div className="header">
          <div className="info">
            <IonIcon src={flagOutline} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}></IonIcon>
            <div>
              <IonLabel placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Chegada</IonLabel>
              <IonLabel placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{dadosOperacao.Item ? ("0" + new Date(dadosOperacao.Item.dataInicio).getHours().toString()).substr(-2) + ":" + ("0" +
                new Date(dadosOperacao.Item.dataInicio).getMinutes().toString()).substr(-2) : ""}</IonLabel>
            </div>
          </div>
          <div className="info">
            <IonIcon src={!temHoraFim ? hourglassOutline : flag} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}></IonIcon>
            <div hidden={temHoraFim}>
              <IonLabel placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Aguardando</IonLabel>
              <IonLabel placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{tempoOperacao}</IonLabel>
            </div>
            <div hidden={!temHoraFim}>
              <IonLabel placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Término</IonLabel>
              <IonLabel placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{dadosOperacao.Item ? ("0" + new Date(dadosOperacao.Item.dataEncerramento).getHours().toString()).substr(-2) + ":" + ("0" +
                new Date(dadosOperacao.Item.dataEncerramento).getMinutes().toString()).substr(-2) : ""}</IonLabel>
            </div>
          </div>
        </div>
        <IonList placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
          <IonListHeader lines="full" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            <IonLabel placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Operação</IonLabel>
            {/* ocultados os botoes de validacao e bookmark para o Violeta, nao quer alteraçoes apos o encerramento da operacao */}
            <IonItem hidden={window.localStorage.getItem("cliente") == 'cliente%236bb8a2c0a3a011ec8f09fd411259c88c'} lines="none" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
              <IonButton onClick={() => { changeDataValidacao(dadosOperacao?.Item?.dataValidacao || false) }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                <IonIcon src={dadosOperacao?.Item?.dataValidacao ? checkmarkCircle : checkmarkCircleOutline} color={dadosOperacao?.Item?.dataValidacao ? "tertiary" : "warning2"} style={{ marginRight: '10px' }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}></IonIcon>
                <span style={{ color: 'var(--ion-color-tertiary)' }}>{dadosOperacao?.Item?.dataValidacao ? "validada" : null}</span>
              </IonButton>
              <IonButton onClick={() => { changeBookmark(dadosOperacao?.Item?.gsi5pk || null) }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                <IonIcon slot='start' style={{ position: 'relative' }} src={dadosOperacao?.Item?.gsi5pk ? bookmark : bookmarkOutline} color={dadosOperacao?.Item?.gsi5pk ? "tertiary" : "warning2"} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}></IonIcon>
                <span style={{ color: 'var(--ion-color-tertiary)' }}>{dadosOperacao?.Item?.gsi5pk ? "salva" : null}</span>
              </IonButton>
            </IonItem></IonListHeader>
          <IonItem lines="none" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            <IonIcon icon={cubeOutline} slot="start" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} />
            <div className="contentList">
              <h1>Tipo da operação</h1>
              <h2>{dadosOperacao.Item && dadosOperacao.Item.tipoOperacao ? dadosOperacao.Item.tipoOperacao : "não identificado"}</h2>
              <h2>{exibeTexto}</h2>
            </div>
          </IonItem>
          <IonItem lines="none" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            <IonIcon icon={informationCircleOutline} slot="start" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} />
            <div className="contentList">
              <h1>Status</h1>
              <h2>{dadosOperacao.Item ? dadosOperacao.Item.status : ""}</h2>
            </div>
          </IonItem>
          <IonItem lines="none" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            <IonIcon src={leafOutline} slot="start" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} />
            <div className="contentList">
              <h1>Tipo da carga</h1>
              <h2>{dadosOperacao.Item && dadosOperacao.Item.tipoCarga ? dadosOperacao.Item.tipoCarga : "não identificado"}</h2>
            </div>
          </IonItem>
          <IonItem lines="none" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            <IonIcon icon={timeOutline} slot="start" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} />
            <div className="contentList">
              <h1>Tempo de permanência</h1>
              <div className="horario">
                <IonLabel placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Chegada</IonLabel>
                <IonLabel placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{dadosOperacao.Item ? formatarDataHora(new Date(dadosOperacao.Item.dataInicio)) : ""}</IonLabel>
              </div>
              <div className="horario">
                <IonLabel placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Término</IonLabel>
                <IonLabel placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{dadosOperacao.Item && dadosOperacao.Item.dataEncerramento ? formatarDataHora(new Date(dadosOperacao.Item.dataEncerramento)) : ""}</IonLabel>
              </div>
              <div className="horario">
                <IonLabel placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Duração</IonLabel>
                <IonLabel placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{tempoOperacao}</IonLabel>
              </div>
            </div>
          </IonItem>

          <IonListHeader lines="full" style={{ "display": "block" }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            <IonLabel placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Notas Fiscais</IonLabel>
            <IonItem hidden={temHoraFim} lines="none" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
              <IonIcon src={addCircle} color="primary" onClick={() => { setShowModalCodigoBarrasDigitar(true); /*openScanner();*/ }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}></IonIcon>
            </IonItem>
          </IonListHeader>
          <IonItem lines="none" hidden={dadosOperacao.Item ? (dadosOperacao.Item.operacaoChaveAcesso === "0" ? true : false) : false} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            <IonIcon src={receiptOutline} slot="start" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} />
            <div className="contentList">
              <h1>Nota Fiscal</h1>
              <h2>{dadosOperacao.Item ? dadosOperacao.Item.operacaoChaveAcesso.substr(25, 9) : ""} </h2>
            </div>
            <IonIcon slot="end" color="primary" src={eye} onClick={() => { window.open("https://www.nfe.fazenda.gov.br/portal/consultaRecaptcha.aspx?tipoConsulta=completa&nfe=" + (dadosOperacao.Item ? dadosOperacao.Item.operacaoChaveAcesso : ""), '_blank'); /* tipoConteudo=7PhJ+gAVw2g=& */ }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} ></IonIcon>
          </IonItem>
          {notasAdicionais.map((notasValue: any, index: any) => (
            <IonItem lines="none" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
              <IonIcon src={receiptOutline} slot="start" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} />
              <div className="contentList">
                <h1>Nota Fiscal</h1>
                <h2 style={{ display: 'flex', alignItems: 'center' }}>{notasValue ? notasValue.notaFiscal.substr(25, 9) : ""}</h2>
                <h1>Chave acesso: {notasValue ? notasValue.notaFiscal : ""}</h1>
                <h1 hidden={notasValue?.anotacao ? false : true}>Anotação: {notasValue?.anotacao ? notasValue.anotacao : ""}</h1>
              </div>
              <IonNote hidden={true} slot="end" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{notasValue ? notasValue.tipoOperacao : ""}</IonNote>
              <IonIcon hidden={false} style={{ marginLeft: '10px' }} src={barcodeOutline} slot="end" onClick={() => { setBoletoNota(notasValue ? notasValue.notaFiscal.substr(25, 9) : ""); setShowModalBoletosDigitar(true); }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} />
              <IonIcon style={{ marginLeft: '10px' }} src={copyOutline} slot="end" onClick={() => { funcCopyNota(notasValue ? notasValue.notaFiscal : ""); }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} />
              <IonIcon hidden={false} style={{ marginLeft: '10px' }} src={informationCircleOutline} slot="end" onClick={() => { console.log('nota clicada', index); setStateSelectedNotaPosicao(index); setStateSelectedNota(notasValue ? notasValue.notaFiscal.substr(25, 9) : ""); setStateSelectedNotaAnotacao(notasValue?.anotacao ? notasValue.anotacao : ""); setStateShowAlertNotaInfo(true); }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} />
              <IonIcon hidden={temHoraFim} style={{ marginLeft: '10px' }} src={trashOutline} slot="end" onClick={() => { console.log('nota clicada', index); setStateSelectedNotaPosicao(index); setStateSelectedNota(notasValue ? notasValue.notaFiscal.substr(25, 9) : ""); setAlertConfirmarExcluirNotaFiscal(true); }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} />
              <IonIcon hidden={false} slot="end" color="primary" src={eye} onClick={() => { window.open("http://www.nfe.fazenda.gov.br/portal/consultaRecaptcha.aspx?tipoConsulta=completa&nfe=" + (notasValue ? notasValue.notaFiscal : ""), '_blank'); /*window.open("http://www.nfe.fazenda.gov.br/portal/consultaRecaptcha.aspx?tipoConteudo=XbSeqxE8pl8=&tipoConsulta=completa&nfe=" + (notasValue ? notasValue.notaFiscal : ""), '_blank')*/ }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} ></IonIcon>
            </IonItem>
          ))}

          <IonListHeader lines="full" style={{ "display": "block" }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            <IonLabel placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Boletos</IonLabel>
            <IonItem hidden={false} lines="none" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
              <IonIcon src={addCircle} color="primary" onClick={() => { setShowModalBoletosDigitar(true); /*openScanner();*/ }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}></IonIcon>
            </IonItem>
          </IonListHeader>

          {boletos.map((boletosValue: any, index: any) => (
            <IonItem lines="none" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
              <IonIcon src={barcodeOutline} slot="start" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} />
              <div className="contentList">
                <h1>Boleto</h1>
                <h2 style={{ display: 'flex', alignItems: 'center' }}>{funcFormataLinha(boletosValue.linhaDigitavel ? boletosValue.linhaDigitavel : "")}</h2>
                <h1 style={{ color: 'var(--ion-color-primary)' }}>{boletosValue.notaFiscal ? "nota: " + boletosValue.notaFiscal : ""}</h1>
              </div>
              <IonNote hidden={false} slot="end" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}><div><div>R$ {boletosValue.valor}</div><div>{boletosValue.vencimento}</div></div></IonNote>
              <IonIcon hidden={temHoraFim} style={{ marginLeft: '10px' }} src={trashOutline} slot="end" onClick={() => { console.log('boleto clicado', index); setStateSelectedBoletoPosicao(index); setStateSelectedBoleto(boletosValue.linhaDigitavel ? boletosValue.linhaDigitavel : ""); setAlertConfirmarExcluirBoleto(true); }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} />
              <IonIcon color="primary" src={copyOutline} slot="end" onClick={() => { funcCopy(boletosValue.linhaDigitavel); }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} />
            </IonItem>
          ))}

          <IonListHeader lines="full" style={{ "display": "block", marginBottom: '10px' }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            <IonLabel placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Status</IonLabel>
          </IonListHeader>
          {
            dadosOperacao?.Item?.anotacoes?.filter((anotacao: any) => anotacao.tipo && anotacao.tipo == "Status").sort(function (a: any, b: any) {
              if (a.data < b.data) {
                return 1;
              }
              if (a.data > b.data) {
                return -1;
              }
              // a must be equal to b
              return 0;
            }).map((anotacoesValue: any) => (
              <div style={{ marginBottom: '4px', width: '100%', borderRadius: '10px' }}>

                <IonItem lines='none' style={{ '--min-height': 'auto', width: '100%' }} color='#green' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                  <IonNote style={{ marginRight: '15px' }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{new Date(anotacoesValue.data).toLocaleString()}&nbsp;</IonNote>
                  <IonLabel color='black' class="ion-text-wrap" style={{ margin: '0px', fontSize: '14px', fontWeight: 'bold', fontFamily: 'Open Sans, sans-serif', lineHeight: '16px' }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{anotacoesValue.anotacao}<span style={{ fontSize: '10px', color: '#666', fontWeight: 'lighter' }}>{" (" + (anotacoesValue.pessoa || "") + ")"}</span></IonLabel>
                </IonItem>
                {/*
                                    <IonItem lines='none' style={{ '--min-height': 'auto', width: '100%' }}>
                                        <IonLabel color='black' style={{ margin: '0px', fontSize: '11px', fontFamily: 'Open Sans, sans-serif', lineHeight: '14px' }}>{new Date(anotacoesValue.data).toLocaleString()}</IonLabel>
                                    </IonItem>
                                    */}
              </div>))
          }

          <IonListHeader lines="full" style={{ "display": "block", marginBottom: '10px' }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            <IonLabel placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Anotações</IonLabel>
          </IonListHeader>
          {
            dadosOperacao?.Item?.anotacoes?.filter((anotacao: any) => !anotacao.tipo || anotacao.tipo != "Status").sort(function (a: any, b: any) {
              if (a.data < b.data) {
                return 1;
              }
              if (a.data > b.data) {
                return -1;
              }
              // a must be equal to b
              return 0;
            }).map((anotacoesValue: any) => (
              <div style={{ marginBottom: '4px', width: '100%', borderRadius: '10px' }}>

                <IonItem lines='none' style={{ '--min-height': 'auto', width: '100%' }} color='#green' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                  <IonNote style={{ marginRight: '15px' }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{new Date(anotacoesValue.data).toLocaleString()}&nbsp;</IonNote>
                  <IonLabel color='black' class="ion-text-wrap" style={{ margin: '0px', fontSize: '14px', fontWeight: 'bold', fontFamily: 'Open Sans, sans-serif', lineHeight: '16px' }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{anotacoesValue.anotacao}<span style={{ fontSize: '10px', color: '#666', fontWeight: 'lighter' }}>{" (" + (anotacoesValue.pessoa || "") + ")"}</span></IonLabel>
                </IonItem>
                {/*
                                    <IonItem lines='none' style={{ '--min-height': 'auto', width: '100%' }}>
                                        <IonLabel color='black' style={{ margin: '0px', fontSize: '11px', fontFamily: 'Open Sans, sans-serif', lineHeight: '14px' }}>{new Date(anotacoesValue.data).toLocaleString()}</IonLabel>
                                    </IonItem>
                                    */}
              </div>))
          }



          <IonListHeader lines="full" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            <IonLabel placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Motorista</IonLabel>
          </IonListHeader>
          <IonItem lines="none" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            <IonIcon src={personOutline} slot="start" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} />
            <div className="contentList">
              <h1>Nome</h1>
              <h2>{dadosOperacao.Item && dadosOperacao.Item.motoristaNome ? dadosOperacao.Item.motoristaNome : "não identificado"}</h2>
            </div>
          </IonItem>
          <IonItem lines="none" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            <IonIcon src={cardOutline} slot="start" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} />
            <div className="contentList">
              <h1>Documento</h1>
              <h2>{dadosOperacao.Item && dadosOperacao.Item.motoristaDocumento ? dadosOperacao.Item.motoristaDocumento : "não identificado"}</h2>
            </div>
          </IonItem>
          <IonItem lines="none" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            <IonIcon src={carOutline} slot="start" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} />
            <div className="contentList">
              <h1>Veículo</h1>
              <h2>{dadosOperacao.Item && dadosOperacao.Item.veiculo ? dadosOperacao.Item.veiculo : "não identificado"}</h2>
            </div>
          </IonItem>
          <IonListHeader lines="full" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            <IonLabel placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Local</IonLabel>
          </IonListHeader>
          <IonItem lines="none" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            <IonIcon src={navigateOutline} slot="start" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} />
            <div className="contentList">
              <h1>Endereço</h1>
              <h2>{dadosOperacao.Item ? dadosOperacao.Item.clienteEndereco : ""}</h2>
              <div style={{ paddingTop: "10px", display: "flex", columnGap: "20px", justifyContent: "left" }} >
                <a target='_blank' href={"https://www.google.com/maps/search/?api=1&query=" + (dadosOperacao.Item ? dadosOperacao.Item.clienteLatitude.concat(",").concat(dadosOperacao.Item.clienteLongitude).concat("&query_place_id=").concat(dadosOperacao.Item.clienteCodigo || "") : "")}><img src={maps} alt="maps" /></a>
                <a target='_blank' href={"https://waze.com/ul?ll=" + (dadosOperacao.Item ? dadosOperacao.Item.clienteLatitude.concat("%2C").concat(dadosOperacao.Item.clienteLongitude) : "") + "&navigate=yes"}><img src={waze} alt="waze" /></a>
              </div>
            </div>
          </IonItem>
          <IonItem lines="full" hidden={true} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            <IonIcon src={iconHorario} slot="start" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} />
            <div className="contentList">
              <h1>Horários de Funcionamento</h1>
              {loadHorarios()}
            </div>
          </IonItem>
          <IonItem lines="full" hidden={true} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            <IonIcon src={iconTempo} slot="start" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} />
            <div className="contentList">
              <h1>Tempos Médios de Carga/Descarga</h1>
              <div className="horario">
                <IonLabel placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Histórico</IonLabel>
                <IonLabel placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{estabelecimento.medias.historico}</IonLabel>
              </div>
              <div className="horario">
                <IonLabel placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Hoje</IonLabel>
                <IonLabel placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{estabelecimento.medias.hoje}</IonLabel>
              </div>
            </div>
          </IonItem>
          <IonListHeader hidden={false} lines="full" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            <IonLabel placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Ocorrências</IonLabel>
            <IonItem hidden={temHoraFim} lines="none" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
              <IonIcon src={addCircle} color="primary" onClick={async () => { await takePhoto(params.operacaoid).catch((e) => { console.log("cancelado"); }); }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}></IonIcon>
            </IonItem>
          </IonListHeader>
          <IonItem hidden={false} lines="none" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>

            <IonGrid placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
              <IonRow placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                {photos.map((photo, index) => (
                  <IonCol size="6" key={index} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                    <div>
                      <a target='_blank' href={photo.webviewpath}>
                        <IonImg src={photo.webviewpath} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} />
                      </a>
                    </div>
                  </IonCol>
                ))}
              </IonRow>
            </IonGrid>

          </IonItem>
        </IonList>
        <IonActionSheet
          backdropDismiss={true}
          translucent={true}
          isOpen={showActionSheet}
          onDidDismiss={() => setShowActionSheet(false)}
          cssClass='my-custom-class'
          buttons={[{
            text: 'Encerrar Operação',
            icon: checkmarkCircle,
            handler: () => {
              setAlertConfirmar(true);
            }
          }, {
            text: 'Cancelar',
            icon: close,
            role: 'cancel',
            handler: () => {
              console.log('Cancel clicked');
            }
          }]}
        />
        <IonAlert isOpen={alertConfirmar}
          onDidDismiss={() => setAlertConfirmar(false)}
          header={'Encerrar operação'}
          message={'Realizar <strong>encerramento</strong>?'}
          buttons={[
            {
              text: 'Cancelar',
              role: 'cancel',
            },
            {
              text: 'Confirmar',
              cssClass: 'primary',
              handler: async () => {
                await encerrar2().then(res => {
                  //const res = await resp.json();
                  //if (res.message) {
                  console.log(res);
                  history.replace("/cliente/operacoesNovo", { recarregar: true });
                }).catch(() => console.log("Erro na chamada"));
              }
            }
          ]}
        />
        <IonAlert
          isOpen={stateShowAlertNotaInfo}
          onDidDismiss={() => setStateShowAlertNotaInfo(false)}
          cssClass="my-custom-class"
          header={'Anotação na nota'}
          message={'Nota: ' + stateSelectedNota}
          backdropDismiss={false}
          inputs={[
            {
              name: 'mensagem',
              type: 'textarea',
              id: 'name2-id',
              value: stateSelectedNotaAnotacao,
              placeholder: 'Digite a anotação',
            }]}
          buttons={['Cancel', {
            text: 'Ok', handler: async (d) => {
              console.log(d.mensagem || "");
              funcAlterarNotaFiscal(stateSelectedNotaPosicao, d.mensagem || "");
            }
          }]}
        />
        <IonAlert isOpen={alertConfirmarExcluirNotaFiscal}
          onDidDismiss={() => setAlertConfirmarExcluirNotaFiscal(false)}
          header={'Excluir nota'}
          message={'Realizar <strong>exclusão</strong> da nota ' + stateSelectedNota + '?'}
          buttons={[
            {
              text: 'Cancelar',
              role: 'cancel',
            },
            {
              text: 'Confirmar',
              cssClass: 'primary',
              handler: async () => {
                funcExcluirNotaFiscal(stateSelectedNotaPosicao);
              }
            }
          ]}
        />
        <IonAlert isOpen={alertConfirmarExcluirBoleto}
          onDidDismiss={() => setAlertConfirmarExcluirBoleto(false)}
          header={'Excluir boleto'}
          message={'Realizar <strong>exclusão</strong> do boleto ' + funcFormataLinha(stateSelectedBoleto) + '?'}
          buttons={[
            {
              text: 'Cancelar',
              role: 'cancel',
            },
            {
              text: 'Confirmar',
              cssClass: 'primary',
              handler: async () => {
                funcExcluirBoleto(stateSelectedBoletoPosicao);
              }
            }
          ]}
        />
      </IonContent>
      <IonFooter className="ion-no-border" hidden={(hideButton || temHoraFim)} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} >
        <IonToolbar placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
          <IonButton size="small" expand="block" onClick={() => setShowActionSheet(true)} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Ações</IonButton>
        </IonToolbar>
      </IonFooter>
    </IonPage>
  );


};

export default Acompanhar;